
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generalActions } from '../../../store/general-slice';
import { themeColorTypes } from '../../../enums/themeColorTypes';
import Tooltip from '../tooltip/Tooltip';
import sunIcon from '../../../assests/icons/sun.png';
import moonIcon from '../../../assests/icons/moon.png';
import classes from './ThemeToggle.module.css';

const ThemeToggle = () => {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general);
    const { texts } = useSelector(state => state.translate);
    const isNightMode = general.themeColor === themeColorTypes.dark

    const toggleMode = () => {
        dispatch(generalActions.changeThemeToggle())
    };

    const onKeyDown = e => {
        if (e.key === 'Enter') {
            toggleMode();
        }
    };

    return (
        <Tooltip text={isNightMode ? texts.darkMode : texts.lightMode} showTooltip={true}>
            <div aria-checked="true" role='switch' tabIndex={0} className={`${classes.toggleContainer} ${isNightMode ? classes.Dark : classes.Light}`} onClick={toggleMode} onKeyDown={onKeyDown}>
                <div className={classes.track}>
                    <div className={classes.iconWrapper}>
                        <img src={isNightMode ? moonIcon : sunIcon} alt={isNightMode ? texts.darkMode : texts.lightMode} className={`${classes.icon}`} />
                    </div>
                </div>
            </div>
        </Tooltip>
    );
};

export default ThemeToggle;
